import type { SupportedCountry } from "@config";
import { BaseCountryAdapter } from "./base";
import type { MapSearchType } from "@repo/maps";
import type { CurrencyType } from "@repo/database";

export class UnitedStatesAdapter extends BaseCountryAdapter {
  code: SupportedCountry = "us";
  currency: CurrencyType = "USD";
  areaMeasurementUnit = "imperial" as const;

  isZipCode(input: string): boolean {
    return /^\d{5}$/.test(input);
  }

  getLocationTypesForSegments(segments: string[]): MapSearchType[] | undefined {
    if (segments.length === 0) {
      return undefined;
    }

    switch (segments.length) {
      case 1: // state
        return ["region"];
      case 2: // state + county
        return ["district"];
      case 3: // state + county + city or neighborhood
        return ["place", "neighborhood"];
      default:
        return ["place", "neighborhood"];
    }
  }
}

export const us = new UnitedStatesAdapter();
